import { DonationPlan } from '../types/donation-plans';
import { PriceRequest } from './stripe-models';

export type BuildPriceParams = {
  productId?: string;
  nickname: string;
  currencyUpper: string; // 'USD'
  unitAmountMajor: number; // 10.5 -> dólares
  plan: DonationPlan; // plan elegido
};

const ZERO_DEC = new Set(['JPY', 'KRW', 'CLP']);
const getCurrencyDecimals = (c: string) => (ZERO_DEC.has(c) ? 0 : 2);

export function buildPriceRequest({
  productId,
  nickname,
  currencyUpper,
  unitAmountMajor,
  plan,
}: BuildPriceParams): PriceRequest {
  const decimals = getCurrencyDecimals(currencyUpper);
  const factor = Math.pow(10, decimals);
  const unitAmount = Math.round(unitAmountMajor * factor).toString(); // minor units string

  const req: PriceRequest = {
    action: 'Create',
    productId,
    currency: currencyUpper.toLowerCase(),
    unitAmount,
    nickname,
  };

  if (plan.recurring) {
    req.recurring = {
      interval: plan.recurring.interval,
      ...(plan.recurring.interval_count && {
        interval_count: plan.recurring.interval_count,
      }),
    };
  }

  return req;
}
